"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SharingWrapper = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _hooks = require("../../hooks");
var _logger = require("../../logger");
var _FormattedMessage = require("../FormattedMessage");
var _Loader = require("../Loader");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
const CopyLinkPanel = /*#__PURE__*/(0, _react.lazy)(async () => Promise.resolve().then(() => _interopRequireWildcard(require('./CopyLinkPanel'))));
const SharingPanel = /*#__PURE__*/(0, _react.lazy)(async () => Promise.resolve().then(() => _interopRequireWildcard(require('./SharingPanel'))));
const SharingPopup = (0, _mui.styled)(_components.Dialog)(({
  ownerState: {
    isCopyLinkOpen
  },
  theme
}) => ({
  ...(isCopyLinkOpen && {
    [`&.${_components.dialogClasses.header}`]: {
      paddingBottom: theme.spacing(6)
    },
    [`&.${_components.dialogClasses.content}`]: {
      maxWidth: 540
    }
  })
}));
const Wrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  marginTop: theme.spacing(3)
}));
const SharingWrapper = props => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    copyLinkProps,
    isCopyLinkOpen,
    isPanelOpen,
    isPopupOpen,
    isSharingButtonActive,
    onShareButtonClick,
    panelProps,
    popupProps
  } = (0, _hooks.useBasketSharing)(props);
  (0, _logger.logDebug)('Rendering SharingWrapper.tsx, popupProps:', popupProps);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
      fullWidth: true,
      variant: "outlined",
      color: "default",
      "data-testid": getTestId('minibag-share-panel-button'),
      startIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Share, {}),
      disabled: !isSharingButtonActive,
      onClick: onShareButtonClick,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: "shareYourBasket"
      })
    }), isPopupOpen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(SharingPopup, {
      ...popupProps,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [isPanelOpen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
          fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.Loader, {}),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SharingPanel, {
            ...panelProps
          })
        }) : null, isCopyLinkOpen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
          fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.Loader, {}),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(CopyLinkPanel, {
            ...copyLinkProps
          })
        }) : null]
      })
    }) : null]
  });
};
exports.SharingWrapper = SharingWrapper;